/* eslint-disable prettier/prettier */

export default {
  "yesterday": "yesterday",
  "Something went wrong": "Something went wrong",
  "Try again": "Try again",
  "No messages yet": "No messages yet",
  "Your conversations": "Your conversations",
  "Unread": "Unread",
  "Attachment sent": "Attachment sent",
  "A call started": "A call started",
  "Connecting ...": "Connecting ...",
  "Loading ...": "Loading ...",
  "Success": "Success",
  "Error": "Error",
  "Warning": "Warning",
  "Layout": "Layout",
  "Settings changed successfully": "Settings changed successfully",
  "News": "News",
  "Agenda": "Agenda",
  "Join the debate": "Join the debate",
  "Gallery": "Gallery",
  "Move Up": "Move Up",
  "Move Down": "Move Down",
  "Cancel": "Cancel",
  "Save": "Save",
  "Saving...": "Saving...",
  "Content Layout": "Content Layout",
  "Control the layout of the content on your portal here.": "Control the layout of the content on your portal here.",
  "Drawers": "Drawers",
  "Manage the drawers that appear on your portal": "Manage the drawers that appear on your portal",
  "Enable": "Enable",
  "Disable": "Disable",
  "All fields are required": "All fields are required",
  "Add Drawer": "Add Drawer",
  "Delete": "Delete",
  "Enter the name of your drawer ...": "Enter the name of your drawer ...",
  "Enter the URL of your drawer ...": "Enter the URL of your drawer ...",
  "You don't have enough permissions to see this page": "You don't have enough permissions to see this page",
  "This page is accessible only in 'Community' mode": "This page is accessible only in 'Community' mode",
  "Invalid URL": "Invalid URL",
};



// WEBPACK FOOTER //
// ./src/i18n/en.js